module.exports = __webpack_public_path__ + "static/media/imgn-vision.859a1758.jpg";